import React from 'react'

interface CardProps {
  children: React.ReactNode
  className?: string
  padding?: 'none' | 'sm' | 'md' | 'lg'
  style?: React.CSSProperties
}

const padMap = {
  none: 0,
  sm: 16,
  md: 20,
  lg: 28,
}

export function Card({ children, className = '', padding = 'md', style }: CardProps) {
  return (
    <div
      className={className}
      style={{
        background: '#ffffff',
        border: '1px solid #eef0f4',
        borderRadius: 10,
        boxShadow: 'none',
        overflow: 'hidden',
        padding: padMap[padding],
        ...style,
      }}
    >
      {children}
    </div>
  )
}
